import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Select from 'react-select';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import Checkbox from "../../../../common/Checkbox";
import Moment from 'moment';
import "moment/locale/ko";
import { useNavigate, useLocation } from "react-router-dom";

const MachineNCProduceStatistics = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('1');
    const [gridWidth, setGridWidth] = useState('450px');
    const [graphData, setGraphData] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({
        start_date: Moment().format("YYYY-MM-01"),
        end_date: appStore.YYYY_MM_DD(),
        machine_id: "", // 설비
        machine_type: "",
    });
    const [graphTitle, setGraphTitle] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        machine_name: true,
        project_number: true,
        project_name: true,
        start_datetime: true,
        end_datetime: true,
        elapsed_time: true,
        produce_qty: true,
        time_per_piece: true,
    });
    const [machineInfo, setMachineInfo] = useState([]); // 설비 리스트
    const [machineOption, setMachineOption] = useState([]);
    const [FauncYN, setFauncYN] = useState("N");

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
      // 아래의 변수가 변경되면 실행된다. -> MenuID 가 0이면 아직 권한 체크가 되지 않았으므로, 권한 체크 후 조회.
      setKeyword({
          ...keyword,
      });

      setGridWidth('450px');
      
      // [수정] 1. 새 데이터 구조에 맞게 컬럼 재정의
      setColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
        { field: 'machine_name', headerName: '설비명', width: 120, headerAlign: 'center', align:'center'},
        { field: 'project_number', headerName: 'NC코드', width: 100, headerAlign: 'center', align:'center'},
        { field: 'project_name', headerName: 'NC파일명', width: 250, headerAlign: 'center', align:'left'},
        { field: 'start_datetime', headerName: '시작일시', width: 180, headerAlign: 'center', align:'center'},
        { field: 'end_datetime', headerName: '종료일시', width: 180, headerAlign: 'center', align:'center'},
        { field: 'elapsed_time', headerName: '경과시간', width: 120, headerAlign: 'center', align:'center'},
        { field: 'produce_qty', headerName: '생산량', width: 120, headerAlign: 'center', align:'right'},
        { field: 'time_per_piece', headerName: '1개당 가공시간', width: 150, headerAlign: 'center', align:'center'},
      ]);
      
      // [수정] 2. 숨김/표시 컬럼 재정의
      setColumnVisibilityModel({
        id: false,
        machine_name: true,
        project_number: true,
        project_name: true,
        start_datetime: true,
        end_datetime: true,
        elapsed_time: true,
        produce_qty: true,
        time_per_piece: true,
      });
    }, [keyword.start_date, keyword.end_date, keyword.machine_id]);

    useEffect(() => {
      if (String(MenuID) !== String(0) && MenuID != null) {
        handleInitSelect();
        handleMainView(); 
      }
    }, [MenuID]);
    
    const handleInitSelect = () => {
        let type_list = "";
        axios
        .get("/api/SelectCommon/MachineList")
        .then((response) => {
          const optionArray = response.data.map((item) => ({
            value: item.machine_id,
            label: item.machine_name,
          }));
          optionArray.unshift({ value: "", label: "전체" });
          setMachineOption([...new Set(optionArray.map(JSON.stringify))].map(JSON.parse));

          const full_array = [];
          response.data.forEach((item) => {
            if (String(item.machine_type) === "1") {
              setFauncYN("Y");
            }
            full_array.push({
              machine_id: item.machine_id,
              machine_type: item.machine_type,
              machine_name: item.machine_name,
            });
            if (type_list === "") {
              type_list = String(item.machine_type);
            } else {
              type_list = String(type_list) + "," + String(item.machine_type);
            }
          });
          setMachineInfo(full_array);
        })
        .catch((error) => {
          console.log(error);
        });

        // [수정] 3. 여기서도 컬럼 초기화를 새 데이터에 맞춤
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'machine_name', headerName: '설비명', width: 120, headerAlign: 'center', align:'center'},
            { field: 'project_number', headerName: 'NC코드', width: 100, headerAlign: 'center', align:'center'},
            { field: 'project_name', headerName: 'NC파일명', width: 250, headerAlign: 'center', align:'left'},
            { field: 'start_datetime', headerName: '시작일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'end_datetime', headerName: '종료일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'elapsed_time', headerName: '경과시간', width: 120, headerAlign: 'center', align:'center'},
            { field: 'produce_qty', headerName: '생산량', width: 120, headerAlign: 'center', align:'right'},
            { field: 'time_per_piece', headerName: '1개당 가공시간', width: 150, headerAlign: 'center', align:'center'},
        ]);
    };

    const handleInit = () => {
        setTabID('');
    };

    // Grid 데이터 조회
    const handleMainView = () => {
      if(keyword.start_date.length === 10 && keyword.end_date.length === 10 && keyword.start_date >= '2025-01-01' && keyword.end_date >= '2025-01-01' && keyword.start_date <= '2049-12-31' && keyword.end_date <= '2049-12-31'){
        axios.get('/api/p/MachineNCProduceStatistics/List',
            {
            params : {
                start_date : keyword.start_date,
                end_date : keyword.end_date,
                machine_id : keyword.machine_id
            }
        },
        { withCredentials: true }
        )
        .then((response) => { 
            const array = response.data
            .filter(item => Number(item.produce_qty) > 0) 
            .map((item, index) => {
                
                return {
                    ...item,
                    id: index, // DataGrid를 위한 고유 키 부여
                    
                    // 3. 생산량에 3자리 콤마 적용
                    produce_qty: item.produce_qty ? Number(item.produce_qty).toLocaleString() : '0',
                    
                };
            });
            setRows(array);
        })
        .catch((error) => {
            appStore.capture();
        });
      }
    }

    const onDateChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSelectChange = (type, value) => {
        var nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '145px', boxShadow: 'none' } }>
            <div className="menu-action" style={ { height: '55px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleMainView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword" style={ { paddingTop:'5px' } }>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '80px', paddingTop: '7px', fontWeight: 'bold' } }>
                            설비
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select
                                className="menu-keyword-sub-keyword-select"
                                placeholder="설비"
                                onChange={(e) => onSelectChange("machine_id", e.value)}
                                // 타입을 강제로 문자열로 맞춰서 비교하도록 수정
                                value={machineOption.filter((option) => String(option.value) === String(keyword.machine_id))}
                                options={machineOption}
                                noOptionsMessage={() => "조회되는 항목 없음"}
                              />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" style={ { width: '100px', fontWeight: 'bold' } }>
                            조회기간
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px' } }>
                            <input type="date" value={keyword.start_date} name="start_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                        <div className="menu-keyword-sub-title" style={ { textAlign: 'center', width: '50px' } }>
                            ~
                        </div>
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '200px'} }>
                            <input type="date" value={keyword.end_date} name="end_date" onChange={(e) => onDateChange(e) } autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid" style={ { top: '147px' } }>
                <div style={{ width: '100%' }}>
                    <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 247px)', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            getRowId={(row) => `${row.id}`}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineNCProduceStatistics;